var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('back-to-top',{attrs:{"bottom":"50px","right":"50px"}},[_c('div',{staticClass:"scroll-top scroll-to-target primary-bg text-white",attrs:{"data-target":"html"}},[_c('span',{staticClass:"fas fa-hand-point-up"})])]),_c('base-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }